import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.priscriptionlist, { type, payload }) {
    switch (type) {
        case types.OTHER_PRESCRIPTION_LIST_REQUEST:
            return {
                ...initialState.priscriptionlist,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.OTHER_PRESCRIPTION_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.OTHER_PRESCRIPTION_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}